/**
 * Inactivity Timeout View
 */

define(function(require) {
    'use strict';

    var BaseView = require('common/base.view');
    var Form = require('class/form.class');
    var InactivityTimeoutModel = require('portlets/responsible-gaming/inactivity-timeout/inactivity-timeout.model');
    var config = require('config');
    var device = require('util/device.util');

    return BaseView.extend({

        events: {
            'change .fn-inactivity-timeout__type': 'handleTimeoutTypeChange',
            'submit .fn-form-inactivity-timeout': 'handleTimeoutSubmit',
            'focusin .fn-inactivity-timeout-value': 'handleTimeoutValueFocus'
        },

        render: function() {
            this.$el.html(this.tmpl('inactivity-timeout'));

            this.model = new InactivityTimeoutModel();
            this.model.fetch()
                .done(this.renderInactivityTimeout.bind(this))
                .fail(this.renderNetworkError.bind(this));

            return this;
        },

        initialize: function() {
            var range = {
                min: config.get('inactivityTimeoutMin'),
                max: config.get('inactivityTimeoutMax')
            };

            this.validationConfig = {
                inactivityTimeout: {
                    required: true,
                    range: {
                        min: range.min,
                        max: range.max,
                        message: this.translate('playtech.mobile.system.tooltip.range', range.min, range.max)
                    },
                    number: {
                        regexp: /^(\d+)$/
                    }
                }
            };
        },

        renderInactivityTimeout: function() {
            var dataMap = this.model.get('playerDataMap');

            this.$el.html(this.tmpl('inactivity-timeout', {
                value: dataMap.inactivityTimeout,
                defaultValue: config.get('inactivityTimeoutDefault'),
                isDesktop: device.formFactor === 'desktop'
            }));

            this.form = new Form(this.$('.fn-form-inactivity-timeout'), {
                validationConfig: function() {
                    return this.isCasinoDefaultTimeoutSeleceted() ? {} : this.validationConfig;
                }.bind(this)
            });
        },

        handleTimeoutTypeChange: function() {
            this.form.el.inactivityTimeout[this.isCasinoDefaultTimeoutSeleceted() ? 'blur' : 'focus']();
            this.form.validate();
        },

        handleTimeoutValueFocus: function() {
            this.form.data('inactivityTimeoutType', 'personal');
        },

        /**
         * @return {Boolean}
         */
        isCasinoDefaultTimeoutSeleceted: function() {
            return this.form && this.form.data('inactivityTimeoutType') === 'default';
        },

        /**
         * @param {Event} e
         */
        handleTimeoutSubmit: function(e) {
            e.preventDefault();

            this.form.validate().done(function() {
                this.form.showLoading();
                this.model
                    .save({
                        inactivityTimeout: this.isCasinoDefaultTimeoutSeleceted() ? '' : this.form.data('inactivityTimeout')
                    })
                    .always(this.form.hideLoading.bind(this.form))
                    .done(this.success.bind(this))
                    .fail(this.error.bind(this));
            }.bind(this));
        },

        success: function() {
            window.Playtech.API.popup.showPopup({
                content: this.translate('playtech.mobile.ngresponsiblegaming.inactivityTimeout.success')
            });

            this.render();
        },

        error: function(response) {
            this.form.showErrorMessages({
                content: response.data.errorMessage
            });
        }

    });
});

